import { faEllipsisH, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	Button,
	Card,
	Col,
	Dropdown,
	Form,
	Modal,
	Nav,
	Row,
	Table,
} from "@themesberg/react-bootstrap";
import { useContext, useEffect, useState } from "react";
import { IMAGE_HOST } from "../common/constants";
import { ImageResourcesContext } from "../contexts/ImageResourcesContext";
import NotFound from "./NotFound";

const ImageResourcesModal = ({
	showModal,
	setShowModal,
	getAllImageResources,
	uploadImageResource,
}) => {
	const [inputData, setInputData] = useState({ imageType: "", image: null });

	const handleFileChange = (e) => {
		let file = e.target.files[0];
		setInputData({ ...inputData, image: file });
		e.target.value = "";
	};

	const handleOnSubmit = () => {
		if (inputData?.imageType === "" || !inputData?.image) return;

		let formData = new FormData();
		formData.append("subtype", inputData?.imageType);
		formData.append("image", inputData?.image);

		uploadImageResource(
			formData,
			() => {
				getAllImageResources();
				setShowModal(false);
			},
			() => {}
		);
	};

	return (
		<Modal centered size="lg" className="modal-tertiary" show={showModal} onHide={() => {}}>
			<Modal.Header>
				<Button
					variant="close"
					className="btn-close-dark text-dark"
					aria-label="Close"
					onClick={() => {
						setShowModal(false);
					}}
				/>
			</Modal.Header>
			<Modal.Body className=" py-3">
				<div className="px-5">
					<center>
						<h5 className="mb-4">Upload image resources</h5>
					</center>
				</div>

				{inputData && inputData?.image && (
					<Row>
						<Col></Col>
						<Col>
							<center>
								<a
									href={URL.createObjectURL(inputData?.image)}
									target="_blank"
									title="Click to open the image"
								>
									<img
										src={URL.createObjectURL(inputData?.image)}
										alt=""
										width="150px"
									/>
								</a>
							</center>
						</Col>
						<Col></Col>
					</Row>
				)}

				<Row>
					<Col></Col>
					<Col xs={3}>
						<Form.Label>Image Type</Form.Label>
						<Form.Select
							value={inputData?.imageType}
							onChange={(e) =>
								setInputData({ ...inputData, imageType: e?.target?.value })
							}
						>
							<option value="">Select Image Type</option>
							<option value="main_slide">Main Slide</option>
						</Form.Select>
					</Col>
					<Col xs={7}>
						<center>
							<Form.Label>Upload Image</Form.Label>
							<Form.Control
								required
								type="file"
								name="main_slide_image"
								accept="image/*"
								onChange={(e) => handleFileChange(e)}
							/>
						</center>
					</Col>
					<Col></Col>
				</Row>
			</Modal.Body>
			<Modal.Footer>
				<Row>
					<Col lg={12}>
						<div className="mx-4 text-end">
							<Button variant="dark" onClick={() => handleOnSubmit()}>
								Upload
							</Button>
						</div>
					</Col>
				</Row>
			</Modal.Footer>
		</Modal>
	);
};

const ImageResources = () => {
	const { imageResources, getAllImageResources, uploadImageResource, deleteImageResource } =
		useContext(ImageResourcesContext);

	const [showModal, setShowModal] = useState(false);

	const handleDeleteButtonClick = (id) => {
		deleteImageResource(
			id,
			() => getAllImageResources(),
			() => {}
		);
	};

	useEffect(() => {
		getAllImageResources();
	}, []);

	return (
		<>
			{showModal && (
				<ImageResourcesModal
					{...{ showModal, setShowModal, getAllImageResources, uploadImageResource }}
				/>
			)}
			<div className="d-flex justify-content-between align-items-center w-100">
				<Button
					variant="secondary"
					className="mt-4 text-dark"
					onClick={() => setShowModal(!showModal)}
				>
					<FontAwesomeIcon icon={faPlus} className="me-2" />
					Add Image Resources
				</Button>
			</div>
			<div className="py-4">
				<Card>
					{imageResources && imageResources.length > 0 && (
						<>
							<Table>
								<thead className="thead-light">
									<tr>
										<th className="border-0">#ID</th>
										<th className="border-0 text-center">Image</th>
										<th className="border-0 text-center">Type</th>
										<th className="border-0 text-center">Action</th>
									</tr>
								</thead>
								<tbody>
									{imageResources?.map((resource) => (
										<tr>
											<td className="border-0 fw-bold">{resource?.id}</td>
											<td className="border-0  text-center">
												<a
													href={IMAGE_HOST + resource?.link}
													target="_blank"
												>
													<img
														src={IMAGE_HOST + resource?.link}
														alt=""
														width="150px"
													/>
												</a>
											</td>
											<td className="border-0 text-center fw-bold">{resource?.subtype?.toUpperCase()}</td>
											<td className="border-0  text-center">
												<Dropdown>
													<Dropdown.Toggle
														as={Nav.Link}
														className="pt-1 px-0"
													>
														<span className="">
															<FontAwesomeIcon icon={faEllipsisH} />
														</span>
													</Dropdown.Toggle>
													<Dropdown.Menu>
														<Dropdown.Item
															onClick={() =>
																handleDeleteButtonClick(
																	resource?.id
																)
															}
														>
															<FontAwesomeIcon icon={faTrash} />{" "}
															Delete
														</Dropdown.Item>
													</Dropdown.Menu>
												</Dropdown>
											</td>
										</tr>
									))}
								</tbody>
							</Table>
						</>
					)}
					{(!imageResources || imageResources.length === 0) && (
						<center className="my-4">
							<NotFound isData={true} />
						</center>
					)}
				</Card>
			</div>
		</>
	);
};

export default ImageResources;
